import $ from 'jquery';
class Bursary {
    constructor(){
        if ($(".transaction-cb").length != 0){
            this.events();
        }
    }

    events() {
        $(".transaction-cb").on("change", this.cbChanged.bind(this));
        $(".delete-bursary").on("click", this.bursaryDeleteDialog.bind(this));
    }
    cbChanged(e){
        this.toggleApproval(e);
    }
    toggleApproval(e){
        var approved = ($(e.target).is(":checked"))?"true":"false";
        var restData = {
            'BURSARY_TRANSACTION': $(e.target).data('postid'),
            'APPROVAL': approved
        };
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/toggleBursaryApproval/',
            data: restData,
            type: 'POST',
            success: (response) =>{
                //  Update the totals screens
                var waitingCount = parseInt($("#bursary_grants_waiting").html(),10);
                var approvedCount = parseInt($("#bursary_grants_approved").html(), 10);
                if ($("#bursary_grant_remaining").html() != "Unlimited"){
                    var grantRemaining = parseInt($("#bursary_grant_remaining").html().replace("£",""),10);
                }
                var bursaryValue = parseInt($("#bursary_value").html().replace("£",""),10);
                if (approved == "true") {
                    waitingCount--;
                    approvedCount++;
                    ($("#bursary_grant_remaining").html() != "Unlimited")?grantRemaining = grantRemaining - bursaryValue:true;
                    $(e.target).parent().parent().next().children().addClass("d-none");
                }
                else {
                    waitingCount++;
                    approvedCount--;
                    ($("#bursary_grant_remaining").html() != "Unlimited")?grantRemaining = grantRemaining + bursaryValue:true;

                    $(e.target).parent().parent().next().children().removeClass("d-none");
                }
                $("#bursary_grants_waiting").html(waitingCount);
                $("#bursary_grants_approved").html(approvedCount);

                if ($("#bursary_grant_remaining").html() != "Unlimited"){
                    $("#bursary_grant_remaining").html( grantRemaining.toLocaleString('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                  }));
                }
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
    }

bursaryDeleteDialog(e){
    $('.dialog-text').text('Are You Sure?');
    $('#dialog-confirm').dialog({
        resizable: false,
        height: "auto",
        draggable: false,
        width: 400,
        modal: true,
        show: {
            effect: "fadeIn"
        },
        hide: {
            effect: "fadeOut"
        },
        closeOnEscape: true,
        buttons: [
            {
                text: "Yes",
                click: function(){
                    
                    $(this).dialog("close");
                    deleteBursaryTransaction(e);
                    
                }
            },
            {
                text: "No",
                click: function(){
                    $(this).dialog("close");
                }
            }
        ]
    });

    $('#dialog-confirm').dialog("open");

}
}
function deleteBursaryTransaction(e){
    var btToDelete = {
        'ID': $(e.target).data('postid'),
    };
    $(".mask").height($(document).height());
    $(".mask").show();
    $('#dys-spinner').addClass('d-flex');
    $.ajax({
        beforeSend:(xhr) => {
            xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
        },
        url: dysData.root_url + '/wp-json/dys/v1/deleteBursaryTransaction/',
        type: 'DELETE',
        data: btToDelete,
        success: (response) => {
            //  Now clear transaction from screen
            $(e.target).parent().parent().fadeOut();
            $('#dys-spinner').removeClass('d-flex');
            $(".mask").hide();
            //  adjust totals. Only waiting as delete button only appears if waiting

            var waitingCount = parseInt($("#bursary_grants_waiting").html(),10);
            waitingCount--;
            $("#bursary_grants_waiting").html(waitingCount);
        },
        error: (response) => {
            console.log("Sorry, unable to delete");
            console.log(response);
        }
    });
}


export default Bursary;